<div class="relative flex flex-col w-full" style="max-height: 90vh;">
    <div class="flex flex-row justify-between items-center">
        <div class="text-xl font-bold p-4">{{ isEdit ? 'Editar' : 'Novo' }} salário / cargo</div>
        <div class="p-4">
            <button (click)="clear()" mat-icon-button type="button">
                <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
    </div>

    <div class="overflow-auto px-4 py-2">
        <form [formGroup]="form" class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <mat-form-field class="w-full md:col-span-2">
                <mat-label>Cargo</mat-label>
                <input matInput formControlName="role_title" />
                <mat-error>Campo obrigatório</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Salário</mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="salary_brl"
                    mask="separator.2"
                    [thousandSeparator]="'.'"
                    [decimalMarker]="','"
                    [allowNegativeNumbers]="false"
                    placeholder="0,00"
                />
                <span matTextPrefix>R$&nbsp;</span>
                <mat-error>Campo obrigatório</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Data início</mat-label>
                <input matInput [matDatepicker]="startPicker" formControlName="start_date" placeholder="dd/mm/aaaa" />
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
                <mat-error>Campo obrigatório</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Data fim</mat-label>
                <input matInput [matDatepicker]="endPicker" formControlName="end_date" placeholder="dd/mm/aaaa" />
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="w-full md:col-span-2">
                <mat-label>Observação</mat-label>
                <textarea matInput rows="3" formControlName="observation"></textarea>
            </mat-form-field>
        </form>
    </div>

    <div class="flex justify-end gap-2 px-4 py-4 border-t border-gray-200 dark:border-gray-700">
        <button (click)="clear()" mat-stroked-button type="button" [disabled]="loading">Fechar</button>
        <button (click)="done()" mat-flat-button color="primary" type="button" [disabled]="loading || form.invalid">
            <mat-spinner *ngIf="loading" diameter="18" class="inline-block mr-2"></mat-spinner>
            Salvar
        </button>
    </div>
</div>
